export default __webpack_public_path__ + "static/media/property_443.bec4c4cf.png";